import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export const EventoStickyCTA = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShow(window.scrollY > 600);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className={`md:hidden fixed bottom-0 left-0 right-0 z-40 transition-transform duration-300 ${
        show ? "translate-y-0" : "translate-y-full"
      }`}
      aria-hidden={!show}
    >
      <div className="bg-[#0B1A0B]/95 backdrop-blur border-t border-white/10 px-4 py-3">
        <Link
          to="/evento/aplicar"
          className="w-full inline-flex flex-col items-center justify-center gap-0.5 rounded-full px-4 py-2.5 font-semibold bg-[#4BD084] text-[#112711] text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#4BD084]"
        >
          <span>Quero me candidatar</span>
          <span className="text-[10px] font-medium text-[#112711]/70">
            Seleção de parceiros · Allu Invest
          </span>
        </Link>
      </div>
    </div>
  );
};
